// extracted by mini-css-extract-plugin
export default {"foundersCarousel":"foundersCarousel__3R7Fc"};